import React from 'react'
import { Typography, Link, styled } from "@mui/material";
import { useSelector } from "react-redux";

const Footer = styled("div", {
    shouldForwardProp: (prop) => prop !== "alert",
})(({ theme, open }) => ({
    position: "fixed",
    bottom: 0,
    paddingLeft: open ? "200px" : "65px",
    paddingTop: 8,
    paddingBottom: 8,
    transition: theme.transitions.create("padding-left", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
}));

const AppFooter = () => {
    const isDrawer = useSelector((state) => state.setDrawer);
    return (

        <Footer open={isDrawer}>
            <Typography variant="body2">Copyright © 2018 <Link href="https://www.qntmnet.com/" target="_blank">Starlight.</Link> All rights reserved.</Typography>
        </Footer>
    )
}

export default AppFooter;


